// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics24Circle: FC<Analytics24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-8.412-7.587C7.979 24.803 8.45 25 9 25h16v-2H9V7H7v16c0 .55.196 1.02.588 1.413ZM10 13v9h4v-9h-4Zm5-5v14h4V8h-4Zm5 9v5h4v-5h-4Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Analytics24Circle;
